import React from 'react';

export const Facebook = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <path
        fill="#163e63"
        d="M15 0a15 15 0 00-2.344 29.818V19.336H8.848V15h3.808v-3.3c0-3.759 2.24-5.836 5.666-5.836a23.073 23.073 0 013.358.293v3.687h-1.892a2.167 2.167 0 00-2.444 2.342V15H21.5l-.665 4.336h-3.491v10.482A15 15 0 0015 0z"
      />
    </svg>
  );
};
